"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _numberFormat = _interopRequireDefault(require("./numberFormat"));

var DEFAULT_MEASUREMENT_SYSTEM = 'metric';

function asDistance(distance) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var t = arguments.length > 2 ? arguments[2] : undefined;
  var i18n = arguments.length > 3 ? arguments[3] : undefined;
  var measurementSystem = options.measurementSystem || DEFAULT_MEASUREMENT_SYSTEM;
  var value;
  var label;
  var asKm = ['km', 'mi'].includes(options.unit || 'km');

  if (measurementSystem === 'metric') {
    if (options.type && options.type === 'climb') {
      value = +distance;
    } else if (!options.keepUnit && !asKm && +distance < 1000) {
      value = +distance;
      label = t('generic.m');
    } else {
      value = +distance / 1000;
      label = t('generic.km');
    }
  } else {
    var miles = +distance / 1000 / 1.609344;

    if (!options.keepUnit && !asKm && miles < 1) {
      value = miles * 1760;
      label = t('generic.yards');
    } else {
      value = miles;
      label = t('generic.mi');
    }
  }

  value = (0, _numberFormat["default"])(value, options, i18n);

  if (options.valueOnly) {
    return value;
  }

  if (options.labelOnly) {
    return label;
  }

  if (options.asObject) {
    return {
      value: value,
      label: label
    };
  }

  return "".concat(value, " ").concat(label);
}

var _default = asDistance;
exports["default"] = _default;
//# sourceMappingURL=asDistance.js.map